import api from '../token';

export const AlterImposto = async (dados) => {
  try {
    const response = await api.post('/alterImposto', dados);
    return response.data;
  } catch (error) {
    
    return { success: false, message: error.message };
  }
};
